export default __webpack_public_path__ + "static/media/news.d0f98dbe.jpeg";